module.exports = __webpack_public_path__ + "img/pillar.f8474e30.svg";